import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';
import { removeAccents } from '/@/modules/core/app/helpers/StringHelper';
import { PredefinedCurrency } from '@/modules/predefined/enums/PredefinedCurrency';

export class PredefinedCountry extends Enum {
  id!: number;
  name!: string;
  code!: string;
  currencyId!: number;

  static CANADA: PredefinedCountry = {
    id: 40,
    get name() {
      return Lang.t('admin.canada');
    },
    code: 'CA',
    currencyId: PredefinedCurrency.CAD.id
  };

  static UNITED_STATES: PredefinedCountry = {
    id: 236,
    get name() {
      return Lang.t('predefined.united-states');
    },
    code: 'US',
    currencyId: PredefinedCurrency.USD.id
  };

  static isActiveCountry(id: number): boolean {
    return [PredefinedCountry.UNITED_STATES.id, PredefinedCountry.CANADA.id].includes(id);
  }

  static getNameByKey(key: string): string | undefined {
    return this.getByKey(key, 'id')?.name;
  }

  static getByKey<PredefinedCountry>(
    this: { new (): PredefinedCountry },
    key: string | number,
    prop?: keyof PredefinedCountry
  ): PredefinedCountry | undefined {
    const propKey: keyof PredefinedCountry = prop ?? ('id' as keyof PredefinedCountry);

    if (prop === 'name') {
      return super
        .getValues<PredefinedCountry>()
        .find(
          (item: PredefinedCountry) =>
            removeAccents(item[propKey] as unknown as string) === removeAccents(key as string)
        );
    }

    // @ts-ignore
    return super.getByKey<PredefinedCountry>(key, propKey);
  }
}
